import { TExperimentsState } from '../../types/experiments';

const defaultValue: TExperimentsState = [];

export function experimentsReducer(state: TExperimentsState = defaultValue) {
  return state;
}
